import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { typeMapToast } from '@monorepo/models';

type propsType = {
    setToast: Dispatch<SetStateAction<typeMapToast | null>>;
    toast: typeMapToast | null;
};

export const HTHInteractiveMapToast: FC<propsType> = ({ setToast, toast }) => {

    useEffect(() => {
        if (toast) {
            const t = setTimeout(() => setToast(null), 2000);
            return () => clearTimeout(t);
        }
    }, [toast]);

    if (!toast) {
        return <></>;
    }

    return (
        <div className={`alert alert-${toast.type} position-fixed top-0 start-50 translate-middle-x mt-3 shadow`}
            style={{ minWidth: 250, zIndex: 9999 }}
        >
            {toast.msg}
        </div>
    );
}
